import script from "./FooterDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterDefault.vue?vue&type=script&setup=true&lang=js"

import "./FooterDefault.vue?vue&type=style&index=0&id=404d5095&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-404d5095"]])

export default __exports__